import React, { Component } from 'react';
import { Panel } from 'widgets/default/panel';
import { Header } from 'widgets/default/Header';
import { PanelBody } from 'widgets/default/panel/body';
import Table from '../table/Table';
import TableBody from '../table/Body';
import TableRow from '../table/Row';
import TableColumn from '../table/Column';

class LanguagesWidget extends Component {
  render() {
    const { supplier: { languages } } = this.props

    return (
      <Panel>
        <Header title="Languages" />
        <PanelBody>
          <Table margin="0">
            <TableBody>
              { languages.map(({ name, uid, skill_set }) => (
              <TableRow key={uid}>
                <TableColumn>{ name } { skill_set && <b>({ skill_set })</b> }</TableColumn>
              </TableRow>
            )) }
            </TableBody>
          </Table>
        </PanelBody>
      </Panel>
    )
  }
}

export { LanguagesWidget }
